import React, { useState, useEffect, useContext, useCallback } from 'react';
import Modal from './Modal';
import RiwayatServisForm from './RiwayatServisForm';
import PdfViewerModal from './PdfViewerModal';
import api from '../api/axiosConfig';
import AuthContext from '../context/AuthContext';
import { showSuccessToast, showErrorAlert, showConfirmDialog } from '../utils/alert';
import { FaEdit, FaTrashAlt, FaFilePdf } from 'react-icons/fa';
import './RiwayatDetailModal.css';

const RiwayatDetailModal = ({ show, onClose, kendaraan }) => {
  const [riwayatList, setRiwayatList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isFormOpen, setFormOpen] = useState(false);
  const [isViewerOpen, setViewerOpen] = useState(false);
  const [fileToView, setFileToView] = useState('');
  const [currentEntry, setCurrentEntry] = useState(null);
  const { user } = useContext(AuthContext);

  const fetchDetails = useCallback(async () => {
    if (!kendaraan?._id) return;
    setLoading(true);
    try {
      const { data } = await api.get(`/api/riwayat-servis/detail/${kendaraan._id}`);
      setRiwayatList(data);
    } catch (error) {
      console.error("Gagal mengambil detail riwayat:", error);
    } finally {
      setLoading(false);
    }
  }, [kendaraan]);

  useEffect(() => {
    if (show) {
      fetchDetails();
    }
  }, [show, fetchDetails]);

  // --- FUNGSI INI YANG DIPERBAIKI ---
  const handleSave = async (formData) => {
    const isEditing = !!currentEntry;
    const url = isEditing ? `/api/riwayat-servis/${currentEntry._id}` : '/api/riwayat-servis';
    const method = isEditing ? 'put' : 'post';
    
    try {
      // Jika menambah data baru, tambahkan ID kendaraan ke formData yang sudah ada
      if (!isEditing) {
        formData.append('kendaraan', kendaraan._id);
      }
      
      await api[method](url, formData, { headers: { 'Content-Type': 'multipart/form-data' } });
      setFormOpen(false);
      fetchDetails();
      showSuccessToast(isEditing ? 'Riwayat diperbarui!' : 'Riwayat ditambahkan!');
    } catch (error) { 
      console.error("Gagal menyimpan data:", error);
      showErrorAlert(error.response?.data?.message || 'Gagal menyimpan data.'); 
    }
  };

  const handleDeleteEntry = async (entryId) => {
    const result = await showConfirmDialog("Hapus seluruh entri pada tanggal ini?");
    if (result.isConfirmed) {
      try {
        await api.delete(`/api/riwayat-servis/${entryId}`);
        fetchDetails();
        showSuccessToast('Entri riwayat berhasil dihapus!');
      } catch (error) { showErrorAlert('Gagal menghapus data.'); }
    }
  };
  
  const openFormModal = (entry = null) => {
    setCurrentEntry(entry);
    setFormOpen(true);
  };
  
  const openViewerModal = (file) => {
    setFileToView(file);
    setViewerOpen(true);
  };
  
  if (!show || !kendaraan) return null;

  return (
    <>
      <Modal show={show} onClose={onClose} title={`Riwayat Servis: ${kendaraan.nomorKendaraan}`} size="large">
        {(user.role === 'superadmin' || user.role === 'operator') && (
          <div className="toolbar" style={{ padding: '0 24px 20px 24px', borderBottom: '1px solid #f0f0f0' }}>
            <button className="btn-primary" onClick={() => openFormModal()}>+ Tambah Riwayat Baru</button>
          </div>
        )}
        <div style={{ padding: '24px', overflowY: 'auto' }}>
          {loading ? <p>Memuat riwayat...</p> : riwayatList.length > 0 ? (
            <table className="data-table">
              <thead>
                <tr>
                  <th>Tanggal Servis</th>
                  <th>Service Rutin</th>
                  <th>Servis Insidentil</th>
                  <th>Aksi</th>
                </tr>
              </thead>
              <tbody>
                {riwayatList.map(item => (
                  <tr key={item._id}>
                    <td>{new Date(item.tanggalServis).toLocaleDateString('id-ID')}</td>
                    <td>{item.serviceRutin.join(', ')}</td>
                    <td>{item.serviceInsidentil.join(', ')}</td>
                    <td className="action-buttons">
                      {item.file && <button onClick={() => openViewerModal(item.file)} title="Lihat File"><FaFilePdf /></button>}
                      {(user.role === 'superadmin' || user.role === 'operator') && (
                        <button onClick={() => openFormModal(item)} title="Edit"><FaEdit /></button>
                      )}
                      {user.role === 'superadmin' && (
                        <button onClick={() => handleDeleteEntry(item._id)} title="Hapus"><FaTrashAlt /></button>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            <p style={{textAlign: 'center', color: '#888'}}>Belum ada riwayat servis untuk kendaraan ini.</p>
          )}
        </div>
      </Modal>

      <Modal show={isFormOpen} onClose={() => setFormOpen(false)} title={currentEntry ? "Edit Riwayat Servis" : "Tambah Riwayat Servis"}>
        <RiwayatServisForm existingData={currentEntry} onSave={handleSave} onCancel={() => setFormOpen(false)} />
      </Modal>
      
      <PdfViewerModal show={isViewerOpen} onClose={() => setViewerOpen(false)} fileUrl={`${process.env.REACT_APP_API_URL}/uploads/${fileToView}`} size="large" />
    </>
  );
};

export default RiwayatDetailModal;